import { render, staticRenderFns } from "./GiftUserPopV2.vue?vue&type=template&id=7f84cf9d&scoped=true"
import script from "./GiftUserPopV2.vue?vue&type=script&lang=ts"
export * from "./GiftUserPopV2.vue?vue&type=script&lang=ts"
import style0 from "./GiftUserPopV2.vue?vue&type=style&index=0&id=7f84cf9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84cf9d",
  null
  
)

export default component.exports